export class Log {
    public timeStamp: Date;
    public level: string;
    public message: string;
    public messageTemplate: string;
    public logEvent: string;
    public exception: string;
    public username: string;
    public applicationId: number;

  deserialize(data: any): Log {
    Object.assign(this, data);

    return this;
  }
}
